import React, { useEffect } from "react";
import { blackBackArrowImage, userIconImage } from "../../assets";
import { withRouter } from "react-router-dom";
import Reques from "./components/Reques/Reques";
import Timeline from "./components/Timeline/Timeline";
import RequestInformation from "./components/Request-Information/RequestInformation";
import Comments from "./components/Comments/Comments";
import { useState } from "react";
import { invokeApi } from "../../bl_libs/invokeApi";
import { CircularProgress } from "@material-ui/core";
import { useSockets } from "../../Context/Context-Sockets/ContextSockets";

function RequestDetails(props) {
  const { handleRefreshChatList } = useSockets();

  const [requestData, setRequestData] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [errMessage, setErrMessage] = useState("");

  const fetchRequestDetails = (type) => {
    let requestObj = {
      path: "/api/customer/customer_request_detail",
      method: "POST",
      headers: {
        "x-sh-auth": localStorage.getItem("token"),
      },
    };
    let postData = {
      request_id: `${props.match.params.requestId}`,
    };
    if (type === "loading") {
      setIsLoading(true);
    } else {
      setIsLoading(false);
    }
    requestObj["postData"] = postData;
    invokeApi(requestObj).then((res) => {
      console.log("RESPONSE", res);
      if (res.code === 200) {
        //for refresh chat
        //when ever request details is fetched
        //so we have always updated chat list
        handleRefreshChatList();

        //manage feedback status for indivisual App
        //Based on res.status is 0 or 1,
        //if status===0 then feedback is pending move to timeline status 7
        //if  status===1 it means feedback given move to timeline status 8
        if (res.request.request_timeline_status === 8) {
          res = {
            ...res,
            request: {
              ...res.request,
              request_timeline_status: res.status === 0 ? 7 : 8,
            },
          };
        }

        // cancel request goes back
        if (res.request.request_status === 2) {
          props.history.goBack();
          return;
        }

        setRequestData(res);
        setIsLoading(false);
      } else {
        setErrMessage(res.message);
      }
    });
  };

  const DeleteRequest = () => {
    let requestObj = {
      path: "/api/customer/delete_request",
      method: "POST",
      headers: {
        "x-sh-auth": localStorage.getItem("token"),
      },
    };
    let postData = {
      request_id: `${props.match.params.requestId}`,
    };
    setIsLoading(true);

    requestObj["postData"] = postData;
    invokeApi(requestObj).then((res) => {
      if (res.code === 200) {
        props.history.goBack();
      } else {
      }
    });
  };

  useEffect(() => {
    fetchRequestDetails("loading");
  }, []);

  if (isLoading) {
    return (
      <section id="content-wrapper" className="content-wrapper rating-page">
        <div className="container-fluid">
          <p className="small-text-bold page-title ">
            <img
              className="pointer-point"
              src={blackBackArrowImage}
              onClick={() => props.history.goBack()}
            />
            <span>Request DETAIL</span>
          </p>
          <div className="container-fluid">
            <div className="Circular-Progress">
              <CircularProgress />
            </div>
            {errMessage && (
              <div className="Circular-Progress">
                Error Message: {errMessage}
              </div>
            )}
          </div>
        </div>
      </section>
    );
  }
  return (
    <>
      <section id="content-wrapper" className="content-wrapper rating-page">
        <div className="container-fluid">
          <p className="small-text-bold page-title ">
            <img
              className="pointer-point"
              src={blackBackArrowImage}
              onClick={() => props.history.goBack()}
            />
            <span>Request DETAIL</span>
          </p>

          <div className="rating-wrapper mt-40 mt-m-30">
            <div className="row">
              <div className="col-sm-6 col-12 col-lg-4">
                <Reques
                  fetchRequestDetails={fetchRequestDetails}
                  requestData={requestData}
                  DeleteRequest={DeleteRequest}
                />
                <Timeline requestData={requestData} />
              </div>
              <div className="col-sm-6 col-12 mt-m-30 col-lg-8">
                <RequestInformation
                  requestData={requestData}
                  fetchRequestDetails={fetchRequestDetails}
                />
                {/* {requestData.request.request_timeline_status > 1 && ( */}
                <Comments
                  requestData={requestData}
                  fetchRequestDetails={fetchRequestDetails}
                />
                {/* )} */}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default withRouter(RequestDetails);
